export const ETH = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#627EEA" />
    <path
      d="M15.998 4V12.87L23.495 16.22L15.998 4Z"
      fill="white"
      fillOpacity="0.602"
    />
    <path d="M15.998 4L8.5 16.22L15.998 12.87V4Z" fill="white" />
    <path
      d="M15.998 21.968V27.995L23.5 17.616L15.998 21.968Z"
      fill="white"
      fillOpacity="0.602"
    />
    <path d="M15.998 27.995V21.967L8.5 17.616L15.998 27.995Z" fill="white" />
    <path
      d="M15.998 20.5729L23.495 16.2199L15.998 12.8719V20.5729Z"
      fill="white"
      fillOpacity="0.2"
    />
    <path
      d="M8.5 16.2199L15.998 20.5729V12.8719L8.5 16.2199Z"
      fill="white"
      fillOpacity="0.602"
    />
  </svg>
);
